module.exports = __webpack_public_path__ + "img/google-play.1b1a3600.png";